export const toHHMMSS = (originalInSeconds: number): string =>
  new Date(originalInSeconds * 1000).toISOString().slice(11, 23);

export const formatBytes = (bytes: number, decimals = 2): string => {
  if (!+bytes) return '0 Bytes';

  const k = 1000;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const MEDIA_META_SEPARATOR = ' | ';

export const getMediaMetaText = (
  format: string | null | undefined,
  size: number | null | undefined,
  duration: number | null | undefined
): string =>
  [format, size ? formatBytes(size) : undefined, duration ? toHHMMSS(duration) : undefined]
    .filter((segment): segment is string => Boolean(segment))
    .join(MEDIA_META_SEPARATOR);
